import React, { useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import CreditCard from './CreditCard';
import Pix from './Pix';
import Button from '../../components/Button';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  plan: Plan;
};

const SubscriptionModal: React.FC<Props> = ({ isVisible, plan, onClose }) => {
  const [options, setOptions] = useState<'options' | 'credit_card' | 'pix'>(
    'options'
  );

  const title = useMemo(() => {
    switch (options) {
      case 'credit_card':
        return 'Cartão de Crédito';
      case 'pix':
        return 'PIX';
      default:
        return 'Formas de Pagamento';
    }
  }, [options]);

  const renderContent = () => {
    switch (options) {
      case 'options':
        return (
          <div className="d-flex flex-column align-items-center">
            <Button
              onClick={() => setOptions('pix')}
              className="w-100 d-flex align-items-center justify-content-between p-2"
            >
              <span className="d-flex align-items-center">
                <img
                  src="assets/images/pix-logo.png"
                  alt=""
                  style={{ width: 24, height: 24, marginRight: 10 }}
                />
                PIX
              </span>
              <span
                className="fw-600 font-xsss px-3 py-1"
                style={{ color: '#fff', background: 'transparent' }}
              >
                1 mês
              </span>
            </Button>
            <Button
              onClick={() => setOptions('credit_card')}
              className="w-100 d-flex align-items-center justify-content-between p-2"
              style={{ marginTop: 20 }}
            >
              <span className="d-flex align-items-center">
                <i
                  className={`feather-credit-card font-xs text-white fw-800`}
                  style={{ cursor: 'pointer', marginRight: 10 }}
                />
                Cartão de Crédito
              </span>
              <span
                className="fw-600 font-xsss px-3 py-1"
                style={{ color: '#fff', background: 'transparent' }}
              >
                Recorrente
              </span>
            </Button>
          </div>
        );
      case 'credit_card':
        return <CreditCard plan={plan} />;
      case 'pix':
        return <Pix plan={plan} onClose={onClose} />;
    }
  };

  return (
    <Modal show={isVisible} scrollable={true} centered>
      <Modal.Header
        className="bg-white"
        style={{
          border: 0,
          borderRadius: 0,
          padding: 20,
          borderTopLeftRadius: 10,
          WebkitBorderTopRightRadius: 10,
        }}
      >
        <div className="d-flex align-items-center w-100 justify-content-between">
          <div className="d-flex align-items-center">
            {options !== 'options' && (
              <button
                type="button"
                className="btn btn-link p-0 me-2"
                onClick={() => setOptions('options')}
                aria-label="Voltar"
                style={{ textDecoration: 'none' }}
              >
                <i className="feather-arrow-left font-md text-grey-900" />
              </button>
            )}
            <h1 className="fw-700 text-grey-900 font-md mb-0">{title}</h1>
          </div>
          <button
            type="button"
            className="btn btn-link p-0 ms-2"
            onClick={onClose}
            aria-label="Fechar"
            style={{ textDecoration: 'none' }}
          >
            <i className="feather-x font-xl text-grey-900" />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="bg-white">
        {renderContent()}
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionModal;
